module.exports = __webpack_public_path__ + "static/img/eTong.6aad007.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/eTong.jpg
// module id = BU+k
// module chunks = 1